import { render, staticRenderFns } from "./chip-primary2.vue?vue&type=template&id=42400dbb&scoped=true&"
import script from "./chip-primary2.vue?vue&type=script&lang=js&"
export * from "./chip-primary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42400dbb",
  null
  
)

export default component.exports